<template>
    <div class="online-editor" id="chuguoqing">
        <div class="inside clearfix por" ref="inside">
            <div class="fl editor-template template">
                <div class="template-item demo2">
                    <ul class="title tab_menu">
                        <li class="cp" :class="{current:tabType === 0}" @click="tabList(0);">图文列表</li>
                        <li class="cp" :class="{current:tabType === 1}" @click="tabList(1);">收藏的素材</li>
                    </ul>
                    <div class="tab-box">
                        <div class="template-warp edit-template" :class="{hide:tabType != 0}">
                            <div class="clearfix template-list por" v-for="(item,index) in editList" :key="index" :class="{curr:index === editIndex}">
                                <div class="clearfix" @click="tabEdit(index);">
                                    <div class="template-l fl">
                                        <img :src="item.cover === '' ? 'static/images/big-up-img.png' : item.cover" />
                                    </div>
                                    <div class="fl template-r">
                                        <p class="color-black">{{item.title}}</p>
                                    </div>
                                </div>
                                <div class="move">
                                    <a class="move-up move-a fl" v-if="index != 0" href="javascript:void(0);" title="上移" @click="moveUp(editList,index);"></a>
                                    <a class="move-down move-a fl" v-if="index != editList.length - 1" href="javascript:void(0);" @click="moveDown(editList,index);" title="下移"></a>
                                    <a class="del move-a fr" v-if="index != 0" href="javascript:void(0);" title="删除" @click="delEdit(index);"></a>
                                </div>
                            </div>
                            <div class="clearfix template-list no por">
                                <div class="add-img">
                                    <img src="/static/images/add-img.png" />
                                    <div class="mask clearfix">
                                        <a class="btns btn-blue ac fl" href="javascript:void(0);" @click="addNewpicture();">新建图文</a>
                                        <a class="btns btn-white ac fr" href="javascript:void(0);" @click="tabList(1);">添加收藏的素材</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="template-warp" :class="{hide:tabType != 1}">
                            <div class="clearfix template-list word-list" v-for="(item,index) in myMaterial" :key="index">
                                <div class="template-r">
                                    <h1 class="color-black ovhidden">{{item.title}}</h1>
                                    <p class="ovhidden">{{item.summary}}</p>
                                </div>
                                <a class="edit" href="javascript:void(0);" @click="addMaterial(item.id,index);"><i></i>添加</a>
                            </div>
                            <div class="no-data" v-if="myMaterial === '' && !$parent.showLoad"><span class="text">没有数据哦...</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 编辑器 -->
            <div class="editor-warp fl">
                <!-- <Editor ref="child"></Editor> -->
                <!-- <vue-ueditor-wrap v-model="editList[editIndex].content" :config="myConfig"></vue-ueditor-wrap> -->
                <Ueditor @ready="editorReady" ref="ue" :value="defaultMSG" :ueditorConfig="myConfig"></Ueditor>
                <div class="float-pendant">
                    <a class="color-black data-title addimgtoediter" @click="imgUpdate();" href="javascript:void(0);" data-title="插入图片">
                        <i class="icons img-icon"></i>
                        图片
                    </a>
                    <!-- <a class="color-black data-title zuotuahref" href="javascript:void(0);" @click="start();" data-title="制作图片">
                        <i class="icons hautu-icon"></i>
                        画图
                    </a>  -->
                    <a class="color-black data-title addvideotoediter" @click="videoUpdate();" href="javascript:void(0);" data-title="插入视频">
                        <i class="icons video-icon"></i>
                        视频
                    </a>
                    <a class="color-black data-title addvideotoediter" @click="audioUpdate();" href="javascript:void(0);" data-title="插入音频">
                        <i class="icons audio-icon"></i>
                        音频
                    </a>
                    <a class="color-black data-title" href="javascript:void(0);" data-title="导入URL" @click="addUrl();">
                        <i class="icons import-icon"></i>
                        导入
                    </a>
                </div>
            </div>
            <div class="fr editor-cover bgfff">
                <div class="file">
                    <div class="item">
                        <p class="color-black item-title">封面</p>
                        <div class="upload" :class="{sm:editIndex != 0}">
                            <img :src="editList[editIndex].cover" v-if="editList[editIndex].cover != ''" class="img db"/>
                            <input type="file" class="input-file" name="file" @change="uploadCover($event);" accept="image/gif,image/jpeg,image/jpg,image/png"/>
                        </div>
                    </div>
                    <div class="item">
                        <p class="color-black item-title">文章标题<span class="cl939 fr">{{editList[editIndex].title.length}}/64</span></p>
                        <input type="text" class="input-text w100" maxlength="64" name="title" v-model="editList[editIndex].title" placeholder="必填，请输入标题"/>
                    </div>
                </div>
                <div class="file">
                    <div class="item">
                        <p class="color-black item-title">作者<span class="cl939 fr">{{editList[editIndex].author.length}}/8</span></p>
                        <input type="text" class="input-text w100" maxlength="8" name="title" v-model="editList[editIndex].author" placeholder="选填，请输入作者" />
                    </div>
                    <div class="item">
                        <p class="color-black item-title">文章摘要<span class="cl939 fr">{{editList[editIndex].summary.length}}/120</span></p>
                        <textarea class="input-text w100" maxlength="120" name="" v-model="editList[editIndex].summary" placeholder="选填，如果不填写会默认抓取正文前54个字" rows="" cols=""></textarea>
                    </div>
                    <div class="item">
                        <p class="color-black item-title">原文链接</p>
                        <input type="text" class="input-text w100" v-model="editList[editIndex].link" name="title" placeholder="选填" />
                    </div>
                </div>
                <p v-if="saveTips">自动保存成功</p>
            </div>
  	    </div>
        <div class="foot-bottom ar">
            <button class="btn btn-white" @click="preview();">预览</button>
            <button class="btn btn-blue" @click="saveToMaterial();">保存素材</button>
            <button class="btn btn-white" @click="openUser(1,'同步到微信');">同步到微信</button>
            <button class="btn btn-white"  @click="articleRelease();">文章发布</button>
            <button class="btn btn-white" @click="openUser(2,'邀请群发');" v-if="$parent.vipInfo.level === 20">邀请群发 <i class="icons icon-lock" v-if="$parent.vipInfo.send === 0"></i></button>
        </div>
        <!-- 创可贴 -->
        <!-- <div id="chuangkit-design-button" class="chuangkediv chuangkit-design-button" data-access="22c869271c2c4434ac85aeebb78288d3" data-title="制作图片" data-kind="20" data-imgkind="2" data-reactid=".0.0.k.1.0.1.0"></div> -->
        <!-- 邀请群发 同步到公众号后台-->
        <mediaSelect ref="invitationToGroup" @userCallback="invitationToGroup" :dataArray="mediaList" v-if="mediaList != ''"></mediaSelect>

        <!-- 添加文章链接 -->
        <Dialog ref="urlModal" :callback="saveUrl" width="400" title="导入微信全文">
            <div slot="mdBox">
                <p>请输入微信文章链接</p>
                <input class="input-text mt10" v-model="url" type="text" placeholder=""/>
            </div>
        </Dialog>
        <!-- 添加视频链接 -->
        <Dialog ref="videoModal" :callback="saveVideo" width="400" title="添加视频">
            <div slot="mdBox">
                <p>请输入视频链接</p>
                <input class="input-text mt10" v-model="videoUrl" type="text" placeholder="目前仅支持插入腾讯视频链接"/>
            </div>
        </Dialog>
        <!-- 添加音频链接 -->
        <Dialog ref="audioModal" :callback="saveAudio" width="400" title="添加音频">
            <div slot="mdBox">
                <p>请输入音频链接或点击按钮上传</p>
                <div class="clearfix mt10">
                    <button class="btn-blue fr btn file-btn">
                        <input class="file" type="file" accept="audio/*" capture="microphone" @change="updateAudio($event);">
                        点击上传
                    </button>
                    <div class="hidden"><input class="input-text" v-model="audioUrl" type="text" placeholder=""/></div>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
// import '../../static/v4.js';
import '../../static/UEditor/ueditor.config.js'
import Ueditor from "../components/editor.vue";
import Dialog from '../components/dialog.vue';
import mediaSelect from '../components/mediaSelect.vue';
export default {
    components:{Dialog,mediaSelect,Ueditor},
    data() {
        return {
            defaultMSG: null,
            form: {
                content: ''
            },
            myConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                elementPathEnabled : false,
                wordCount:false,
                maximumWords:'20000',
                enableAutoSave: false,
                saveInterval: 5000000,
                elementPathEnabled: false,
                allowDivTransToP: false,
                // 初始容器高度
                initialFrameHeight: '100%',
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: 'http://gj.gsdata.cn/ueditorphp/controller.php',
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: '/static/UEditor/'
            },
            imagebodyimage:'',//多图上传点击ID
            formType:6,//页面来源
            formId:'',//来源文章ID
            materialType:'',
            editIndex:0,
            pid:'',
            timer:'',//定时器
            mediaList:[],//媒体列表
            myMaterial:[],//我的素材
            editList:[{
                id:'',
                link:'',
                title:'标题',
                pid:'1',
                summary:'',
                author:'',
                content:'',
                cover:''
            }],//我编辑的列表
            saveTips:false,
            isTime:false,//是否重启自动保存
            tabType:0,
            testUser:'',
            url:'',//导入链接
            videoUrl:'',//视频链接
            audioUrl:'',//音频链接
            modalType:''//弹框类别 同步和邀请转发
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {   
            // that.myConfig.initialFrameHeight = this.$refs.inside.offsetHeight - 106 - 51;
            that.getPageData();
            // that.getUesrList();
            that.pageOperation(1);//一分钟用户没有操作关闭定时器
            that.timingSave(0);
            // (function(d,s,a){
			// var w=d.createElement(s),s=d.getElementsByTagName(s)[0];
			// w.src=a;s.parentNode.insertBefore(w,s);
			// })
			//(document,'script','https://static.chuangkit.com/api/v4.js');
			// var strss = 'data-access=22c869271c2c4434ac85aeebb78288d3&data-exp=1624739661000&data-kind=20&data-zIndex=10000B3FFE0CEA28827C70B576A723E0B788F';
        })
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.testUser);
    },
    created() {
        // 获取链接文章来源
        let formType = this.$route.query.formType;
        if(formType != undefined){
            this.formType = formType;
        }
        // 获取链接文章id
        let id = this.$route.query.id;
        if(id != undefined){
            this.formId = id;
        }
        // 获取链接文章id
        let type = this.$route.query.type;
        if(type != undefined){
            this.materialType = type;
        }
    },
    methods: {
        // 创可贴
        start () {
            var sign = CryptoJS.MD5(strss).toString().toUpperCase();
            var	option={
                "data-access":"22c869271c2c4434ac85aeebb78288d3",
                "data-exp":"1624739661000",
                "sign":sign,
                "signType":"MD5",
                "data-kind":20,"data-zIndex":10000,}
            var cktIframe = new ChuangkitIframe(option);	
            cktIframe.openIframe();
        },
        chuangkitComplate (eve) {
            if(typeof(eve["thumb-urls"])!='undefined'){
                var imgurl='http:'+eve["thumb-urls"][0];
                if(imgurl){
                    // getwebimgtolocal(imgurl);            
                }	
            }		 
        },
        // 创可贴结束
        editorReady(instance) {
            instance.setContent(this.form.content);
            instance.addListener('contentChange', () => {
                this.form.content = instance.getContent();
                this.editList[this.editIndex].content = instance.getContent();
            });
        },
        // 获取账户列表
        getUesrList () {
            let that = this;
            let url = 'member/publishlist';
            that.allIds = [];
            that.$api.post(url, {other:0}, r => {
                that.mediaList=[];
                that.$parent.returnCode(r,function(){
                    that.mediaList = r.data;
                })
            })
        },
        // 点击邀请群发
        getUesrList1 () {
            let that = this;
            let url = 'member/publishlist';
            that.allIds = [];
            that.$api.post(url, {other:1}, r => {
                that.mediaList=[];
                that.$parent.returnCode(r,function(){
                    that.mediaList = r.data;
                })
            })
        },
        // 获取数据
        getPageData () {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('editor/editarticle',{type:that.formType,source:that.materialType,sn:that.formId},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.myMaterial = r.data.mymaterial;
                    let editList = r.data.editArticle;
                    if(editList != ''){
                        that.editList = editList;
                    }
                    that.defaultMSG = editList[0].content;
                    that.pid = that.editList[0].pId;
                })
            })
        },
        // 切换列表
        tabList (type) {
            this.tabType = type;
        },
        // 上传封面图
        uploadCover (event) {
            let that = this;
            let file = event.target.files;
            let files = file[0];
            let formData = new FormData();
            formData.append('file', files);
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('mymaterial/upload', formData, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.editList[that.editIndex].cover = r.data;
                })
            })
        },
        //添加素材编辑
        addMaterial (id,index) {
            let that = this;
            if(that.editList.length >= 8){
                that.$utils.alertText('每次最多可添加8条');
                return;
            }
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('editor/ajaxgetmyfavoritesinfo', {id:id,pid:that.pid}, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.tabType=0;
                    that.editList.push(r.data);
                    // let len = that.editList.length;
                    // that.editList[len-1].id = r.data;
                })
            })
        },
        // 切换编辑
        tabEdit (index) {
            let that = this;
            let editList = that.editList;
            that.editIndex = index;
            that.defaultMSG = editList[index].content;
        },
        // 定时保存
        timingSave (type) {
            let that = this;
            that.timer = setInterval(() => {
                that.$api.post('editor/updateedit', {main:JSON.stringify(that.editList),online:that.formType,pid:that.pid}, r => {
                    that.$parent.returnCode(r,function(){
                        if(type === 0){
                            that.saveTipsFn();
                        }
                    })
                })   
            }, 10000);
        },
        saveTipsFn () {
            this.saveTips = true;
            setTimeout(() => {
                this.saveTips = false;
            }, 1500);
        },
        // 新建图文
        addNewpicture () {
            let that = this;
            if(that.editList.length >= 8){
                that.$utils.alertText('每次最多可添加8条');
                return;
            }
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('editor/add', {pid:that.pid}, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    let list = {
                        id:r.data,
                        link:'',
                        title:'标题',
                        summary:'',
                        author:'',
                        content:'',
                        cover:''
                    }
                    that.editList.push(list);
                })
            })  
        },
        // 删除编辑
        delEdit (index) {
            let that = this;
            that.$api.post('editor/del', {id:that.editList[index].id}, r => {
                that.$parent.returnCode(r,function(){
                    that.editList.splice(index,1);
                    if(that.editList.length === 1){
                        that.editIndex = 0;
                    }
                })
            })
        },
        // 上移
        moveUp(arr,index){
            let tempOption = arr[index-1];
            this.$set(arr, index - 1, arr[index]);
            this.$set(arr, index, tempOption)
        },
        // 下移
        moveDown(arr,index){
            let tempOption = arr[index+1];
            this.$set(arr, index + 1, arr[index]);
            this.$set(arr, index, tempOption)
        },
        // 保存先更新
        updateData (callback) {
            let that = this;
            that.$api.post('editor/updateedit', {main:JSON.stringify(that.editList),online:that.formType,pid:that.pid}, r => {
                that.$parent.returnCode(r,function(){
                    callback();
                })
            })
        },
        // 保存校验
        saveCheck () {
            let that = this;
            let editList = that.editList;
            let returnVal = true;
            for(let i of editList){
                let content = i.content;
                let cover = i.cover;
                let title = i.title;
                if(content === ''){
                    that.$parent.alertTips('素材信息不完整，请至少添加标题、缩略图、内容！');
                    returnVal = false;
                }else if(cover === ''){
                    that.$parent.alertTips('素材信息不完整，请至少添加标题、缩略图、内容！');
                    returnVal = false;
                }else if(title === ''){
                    that.$parent.alertTips('素材信息不完整，请至少添加标题、缩略图、内容！');
                    returnVal = false;
                }
            }
            return returnVal;
        },
        // 预览
        preview () {
            let that = this;
            let query = {
                formType:1,
                id:that.editList[that.editIndex].id
            };
            that.updateData(function(){
                let routeData = that.$router.resolve({ path:'/detail',query:query});
                window.open(routeData.href, '_blank');
            })
        },
        // 保存到素材
        saveToMaterial (callback) {
            let that = this;
            let editList = that.editList;
            if(that.saveCheck()){//校验成功才能提交
                that.updateData(function(){
                    that.$parent.loadModal(true,'提交数据中...');
                    that.$api.post('editor/save', {pid:that.pid}, r => {
                        that.$parent.returnCode(r,function(){
                            if(callback != undefined){
                                callback(r.data);
                            }else{
                                that.$parent.showLoad = false;
                                that.$router.push({path:'/materialCenter/myMaterial'});
                            }  
                        })
                    })
                })
            }
        },
        // 同步到微信
        openUser (type,title) {
            let that = this;
            let send = that.$parent.vipInfo.send;
            if(send === 0 && type === 2){//没有权限
                let html = '您没有此权限，请<span class="color-blue">联系管理员开通</span>';
                that.$parent.alertTips(html);
                return;
            }
            if(that.saveCheck()){
                let url = 'member/publishlist';
                that.allIds = [];
                if(type == 2){
                    that.$api.post(url, {other:1}, r => {
                        that.mediaList=[];
                        that.$parent.returnCode(r,function(){
                            that.mediaList = r.data;
                            setTimeout(()=>{
                                that.$refs.invitationToGroup.synchroPublicNumber(type,title);
                                that.modalType = type;
                            },300)
                        })
                    })
                }else{
                    that.$api.post(url, {other:0}, r => {
                        that.mediaList=[];
                        that.$parent.returnCode(r,function(){
                            that.mediaList = r.data;
                            setTimeout(()=>{
                                that.$refs.invitationToGroup.synchroPublicNumber(type,title);
                                that.modalType = type;
                            },300)
                        })
                    })
                }
                

                
            }
        },
        // 保存邀请群发
        invitationToGroup (val) {
            let that = this;
            let url = '';
            let modalType = that.modalType;
            let id1 = [];//同步到微信
            let id2 = [];//邀请群发
            // let articlId = [];//文章ID
            // for(let j of that.editList){
            //     articlId.push(j.id);
            // }
            for(let i of val){
                let arr = [];
                let zhi = i.split('-');
                arr.push(zhi[0],zhi[1]);
                id1.push(zhi[1]);
                id2.push(arr);
            }
            that.saveToMaterial(pid => {
                let data = {};
                if(modalType === 1){//同步
                    url = 'editor/sendtomywx';
                    data = {
                        pid:pid,
                        id:id1
                    }
                }else{//邀请群发
                    url = 'editor/allsend';
                    data = {
                        accountid:id2,
                        pid:pid
                    }
                }
                that.$api.post(url, data, r => {
                    that.$parent.showLoad = false;
                    that.$parent.returnCode(r,function(){
                        that.formType = 6;
                        that.$router.push({path:'/materialCenter/myMaterial'});
                    })
                })
            })
        },
        // 文章发布
        articleRelease () {
            let that = this;
            that.saveToMaterial(pid => {
                that.$parent.showLoad = false;
                that.$router.push({path:'materialCenter/matrixArticle',query:{id:pid}});
            });
        },
        // 图片上传
        imgUpdate () {
            //$('#edui85_body').trigger('click');
            if(this.imagebodyimage==''){
                this.imagebodyimage=$('.edui-for-insertimage').attr("id");
                $('.edui-for-insertimage').find('.edui-button-body').trigger('click');
            }else{
                $('#'+this.imagebodyimage+'_body').trigger('click');
            }
        },
        // 视频上传
        videoUpdate () {
            this.videoUrl = '';
            this.$refs.videoModal.showMaskFun();
            // let funcName = '11111';
            
        },
        // 保存视频
        saveVideo () {
            let videoUrl = this.videoUrl;
            if(videoUrl == ''){
                this.$utils.alertText('请输入视频地址');
            }
            // console.log(videoUrl.indexOf('iframe'));
            let html = '<div class="video-ng"><iframe class="video_iframe" width="100%" height="277.5" style="z-index:1;" frameborder="0" src="'+videoUrl+'" allowfullscreen=""></iframe></div>';
            this.$refs.ue.setText(html);
            this.$refs.videoModal.closeMask();
        },
        // 音频上传
        audioUpdate () {
            this.audioUrl = '';
            this.$refs.audioModal.showMaskFun();
        },
        updateAudio (event) {
            let that = this;
            let file = event.target.files;
            let files = file[0];
            let formData = new FormData();
            formData.append('file', files);
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('mymaterial/uploadfile', formData, r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.audioUrl = r.data;
                })
            })
        },
        //保存音频
        saveAudio () {
            let audioUrl = this.audioUrl;
            if(audioUrl == ''){
                this.$utils.alertText('请输入或上传音频地址');
            }
            // console.log(videoUrl.indexOf('iframe'));
            let html = '<section><audio class="audio" controls src="'+audioUrl+'"></audio></section>';
            this.$refs.ue.setText(html);
            this.$refs.audioModal.closeMask();
        },
        // 添加链接
        addUrl () {
            this.url = '';
            this.$refs.urlModal.showMaskFun();
        },
        // 保存链接
        saveUrl (){
            let that = this;
            let editList = that.editList;
            if(that.url === ''){
                that.$utils.alertText('请输入微信文章链接');
            }
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('editor/importarc',{url:that.url},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.url = '';
                    editList[that.editIndex].content = r.data.content;
                    that.defaultMSG = r.data.content;
                    that.$refs.urlModal.closeMask();
                })
            })
        },
        // 判断用户有无操作
        pageOperation(times){
            let that = this;
            let time = times || 2;    // 默认参数
            let userTime = time*60;
            let objTime = {
                init:0,
                time:function(){
                    objTime.init += 1;
                    if(objTime.init == userTime){
                    // 用户到达未操作事件 做一些处理  
                        that.isTime = true;
                        clearInterval(that.timer);  
                    }
                },
                eventFun:function(){
                    clearInterval(that.testUser);
                    if(that.isTime){
                        that.timingSave(0);
                    }
                    that.isTime = false;
                    objTime.init = 0;
                    that.testUser = setInterval(objTime.time,1000);
                }
            }

            that.testUser = setInterval(objTime.time,1000);

            let body = document.getElementById('chuguoqing');
            body.addEventListener("click",objTime.eventFun);
            body.addEventListener("keydown",objTime.eventFun);
            body.addEventListener("mousemove",objTime.eventFun);
            body.addEventListener("mousewheel",objTime.eventFun);
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/onlineEdit.vue